import React from "react";
import MainLogo from "../Header/MainLogo";
import ProductLogo from "../Header/ProductLogo";

const HeaderLeftSide = ({
  showSeperator,
  productLogo,
  productLogoAltText,
  navigateToProduct,
  productClassName,
  productOnClick,
}) => {
  return (
    <div className="flex items-center lg:gap-4">
      <MainLogo />

      {showSeperator && <div className="border-r w-0 h-[35px] mx-[6.5px]" />}

      <ProductLogo
        productLogo={productLogo}
        productLogoAltText={productLogoAltText}
        onClick={productOnClick || navigateToProduct}
        productClassName={productClassName}
      />
    </div>
  );
};

export default HeaderLeftSide;
